import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import { useHistory } from 'react-router-dom';
import {
  Wrapper,
  FormWrapper,
  FieldWrapper,
  FieldPredictive,
  WrapperButton
} from './styled';
import { RenderSelect } from '@app/src/views/Users/filter/components/RenderSelect';
import { RenderInput } from '@app/src/views/CipReport/filter/components/RenderInput';
import { ModalContainer } from '@app/src/utils/ModalLogout';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

const states = [
  {
    value: '1',
    label: 'Activo'
  },
  {
    value: '0',
    label: 'Inactivo'
  }
];

interface Fields {
  state?: string;
}

interface Props {
  handleSubmit: Function;
  valuesForm: Fields;
  errorMessage: string;
  handleFetchDetail: Function;
  url: string;
  history: any;
  reset: Function;
}

export const Form: React.FC<Props> = ({
  handleSubmit,
  valuesForm,
  handleFetchDetail,
  url,
  reset
}) => {
  const userId = decodeAccessToken('idUser');

  useEffect(() => {
    handleFetchDetail({
      state: 1,
      ...valuesForm,
      userId: userId,
      page: 1,
    }, url);
  }, [valuesForm]);

  const history = useHistory();
  const handleClick = () => {
    history.push('/usuarios/crear');
  }

  return(
    <Wrapper>
      <FormWrapper onSubmit={handleSubmit}>
        <FieldPredictive>
          <Field
            name="fullname"
            label="Usuarios"
            placeholder="Buscar Usuarios"
            component={RenderInput}
          />
        </FieldPredictive>
        <FieldWrapper>
          <Field
            name="state"
            label="Estado"
            component={RenderSelect}
            options={states}
          />
        </FieldWrapper>
      </FormWrapper>
      <WrapperButton icon="user-plus" width="140px" onClick={() => handleClick()}>Nuevo Usuario</WrapperButton>
      <ModalContainer data-test="modal" reset={reset} />
    </Wrapper>
  );
};
